export default "__VITE_ASSET__C9U6ZPWM__"